import React, { useState, Component } from "react";
import { Trans, withTranslation } from "react-i18next";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";

function UploadError(props) {
  return (
    <Snackbar open={!!props.uploadError}>
      <Alert variant="filled" severity="error" onClose={props.setUploadError}>
        <Trans  i18nKey={props.uploadError}/>
      </Alert>
    </Snackbar>
  );
}
export default UploadError;